import {
  CartFulfillState,
  CartQuoteActionTypes,
  CartQuoteEventType,
  CartQuoteState,
  type ChildMachineConfig,
  ParentState,
} from "@hopper-b2b/checkout";
import { Guards } from "../../guards";
import { ActionTypes } from "./actions";
import { CartFulfillEventType } from "./events";
import { ServiceTypes } from "./services";

export const getMachineState = (config: ChildMachineConfig) => ({
  id: ParentState.cartFulfill,
  initial: CartFulfillState.schedule,
  states: {
    [CartFulfillState.schedule]: {
      invoke: {
        src: ServiceTypes.scheduleFulfillService,
        onDone: {
          actions: ActionTypes.setCartFulfillCipherText,
          target: CartFulfillState.pollUserActionRoute,
        },
        onError: {
          actions: ActionTypes.setCartFulfillError,
          target: CartFulfillState.error,
        },
      },
    },
    [CartFulfillState.pollUserActionRoute]: {
      always: [
        {
          cond: Guards.isRyanAir,
          target: CartFulfillState.pollingUserAction,
        },
        {
          target: CartFulfillState.polling,
        },
      ],
    },
    [CartFulfillState.pollingUserAction]: {
      invoke: {
        src: ServiceTypes.pollUserActionService,
        onDone: {
          actions: ActionTypes.setUserAction,
          target: CartFulfillState.userActionRoute,
        },
        onError: {
          target: CartFulfillState.error,
        },
      },
    },
    [CartFulfillState.userActionRoute]: {
      always: [
        {
          cond: Guards.hasNoUserAction,
          target: CartFulfillState.polling,
        },
        // We can remove this state and directly go to polling in the case of Ryanair as well, but keeping it for now for better clarity in the flow.
        { target: CartFulfillState.polling },
      ],
    },
    // Intentionally left empty for useraction in cartFulfill's component
    [CartFulfillState.userAction]: {},
    [CartFulfillState.polling]: {
      invoke: {
        src: ServiceTypes.pollFulfillService,
        onDone: {
          actions: ActionTypes.setCartFulfillPurchaseResult,
          target: config.nextState,
        },
        onError: {
          actions: ActionTypes.setCartFulfillError,
          target: CartFulfillState.error,
        },
      },
    },
    [CartFulfillState.error]: {
      on: {
        [CartFulfillEventType.OPEN_PASSENGER_PICKER]: `#${config.parentMachineId}.${ParentState.passengerInformation}`,
      },
    },
  },
  on: {
    [CartFulfillEventType.CLEAR_CART_FULFILL_ERROR]: {
      actions: ActionTypes.clearCartFulfillError,
    },
    [CartQuoteEventType.RETRY_QUOTE]: {
      target: `#${config.parentMachineId}.${ParentState.cartQuote}.${CartQuoteState.route}`,
      actions: [
        CartQuoteActionTypes.setQuoteRetries,
        CartQuoteActionTypes.clearCartQuoteError,
      ],
    },
    [CartFulfillEventType.USER_ACTION_SUCCESS]: {
      actions: [ActionTypes.clearCartFulfillError],
      target: `#${config.parentMachineId}.${ParentState.cartFulfill}.${CartFulfillState.polling}`,
    },
    [CartFulfillEventType.USER_ACTION_ERROR]: {
      target: `#${config.parentMachineId}.${ParentState.cartFulfill}.${CartFulfillState.polling}`,
    },
  },
});
